<span class="mbs-status-ico"
      [ngClass]="iconClasses$ | async"></span>
<span #ngContentWrapperRef
      *ngIf="showStatusText$ | async"
      [ngClass]="textClasses$ | async"
      class="mbs-status-text">
  <ng-content></ng-content>
</span>
